










































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

import { Getter } from "vuex-class";

import { Watch } from "vue-property-decorator";

import { Route } from "vue-router";

import PageTitleBar from "../ui/PageTitleBar.vue";

import { Locales, LOCALES } from "../../i18n/locales";

import { Language } from "../../models/Language";

import { updateTranslation } from "../../i18n";
import api from "@/network/api";
import { AxiosResponse } from "axios";

import LogoutTimer from "../features/LogoutTimer.vue";

@Component({
  components: {
    PageTitleBar,
    LogoutTimer,
  },
})
export default class AppHeader extends Vue {
  @Getter("isAuthenticated") private isAuthurized!: boolean;
  @Getter("userName") private userName!: string;
  @Getter("fullName") private fullName!: string;
  @Getter("userAvatar") private userAvatar!: string;
  @Getter("userLanguageId") private currentLanguage!: Language;
  @Getter("eventId") private eventId!: number;
  @Getter("userSource") private userSource!: number;
  @Getter("userHelpButtonEnabled") private userHelpButtonEnabled!: boolean;
  private menuToggle = false;
  private boothsTrainingMenuToggle = false;
  private boothsChallengeMenuToggle = false;
  private mobileMenuToggle = false;
  private mobileBoothTrainingHallToggle = false;
  private mobileBoothChallengeHallToggle = false;

  filterBoothGames: any = [];
  boothGames: any = [];
  filterBoothLessons: any = [];
  boothLessons: any = [];
  boothInteractive: any = [];
  notifications: any = [];

  private currentLang: any = {};

  changeLanguageAnon() {
    let language;

    if (this.currentLang.code === Locales.EN) {
      language = LOCALES.find((obj) => obj.code === Locales.AR);
      updateTranslation(language as Language);
      this.currentLang = language as Language;
    } else if (this.currentLang.code === Locales.AR) {
      language = LOCALES.find((obj) => obj.code === Locales.EN);
      updateTranslation(language as Language);
      this.currentLang = language as Language;
    }
  }

  changeLanguage() {
    let language;

    if (this.currentLanguage.code === Locales.EN) {
      language = LOCALES.find((obj) => obj.code === Locales.AR);
      updateTranslation(language as Language);
      this.$store.dispatch("changeLanguage", language);
    } else if (this.currentLanguage.code === Locales.AR) {
      language = LOCALES.find((obj) => obj.code === Locales.EN);
      updateTranslation(language as Language);
      this.$store.dispatch("changeLanguage", language);
    }

    if (
      this.$router.currentRoute.name == "Booths" ||
      this.$router.currentRoute.name == "Game Room" ||
      this.$router.currentRoute.name == "Training Room"
    ) {
      location.reload();
    }
  }

  created() {
    this.currentLang = this.currentLanguage;
    this.registerNotificationsJob();
  }

  hideSideMenu(event: FocusEvent) {
    if (!event.relatedTarget) {
      this.menuToggle = false;
    }
  }

  toggleTrainingHallMenu() {
    this.boothsTrainingMenuToggle = false;
    this.boothsChallengeMenuToggle = false;
    this.boothsTrainingMenuToggle = !this.boothsTrainingMenuToggle;
  }

  toggleChallengeHallMenu() {
    this.boothsTrainingMenuToggle = false;
    this.boothsChallengeMenuToggle = false;
    this.boothsChallengeMenuToggle = !this.boothsChallengeMenuToggle;
  }

  toggleMobileMenu() {
    this.mobileMenuToggle = !this.mobileMenuToggle;
  }
  toggleMobileTrainingHall() {
    this.mobileBoothTrainingHallToggle = false;
    this.mobileBoothChallengeHallToggle = false;
    this.mobileBoothTrainingHallToggle = !this.mobileBoothTrainingHallToggle;
  }

  toggleMobileChallenegHall() {
    this.mobileBoothTrainingHallToggle = false;
    this.mobileBoothChallengeHallToggle = false;
    this.mobileBoothChallengeHallToggle = !this.mobileBoothChallengeHallToggle;
  }

  logout() {
    this.$store.dispatch("logout");
  }

  loadNotifications() {
    api.get("notifications").then((res: AxiosResponse) => {
      this.notifications = res.data.notifications;
    });
  }

  notificationsHandle: any;
  @Watch("eventId")
  createSubscribtion() {
    if (this.isAuthurized) {
      this.$socket.client.on(
        "interactive_events_platform_database_NewNotification." + this.eventId,
        (payload: any) => {
          if (this.notifications.length > 0) {
            let index: any = -1;
            this.notifications.forEach(function (obj: any, id: any) {
              if (obj.id == payload.notification.id) {
                index = id;
              }
            });
            if (index == -1) {
              this.notifications.splice(0, 0, payload.notification);
            } else {
              this.notifications.splice(index, 1, payload.notification);
            }
          } else {
            this.loadNotifications();
          }

          // popup the notification
          const notificationMessage =
            payload.notification.details[this.$i18n.locale];
          (Vue as any).$toast.info(
            `<div style='width: 300px; padding: 10px;'>${notificationMessage}</div>`,
            {
              position:
                this.$i18n.locale === Locales.EN ? "top-right" : "top-left",
              duration: 5000,
            }
          );
        }
      );

      this.$socket.client.on("interactive_events_platform_database_DeleteNotification." + this.eventId,
        (payload: any) => {
          if (this.notifications.length > 0) {
            let index = -1;
            this.notifications.forEach(function (obj: any, id: number) {
              if (obj.id == payload.notification.id) {
                index = id;
              }
            });
            if (index >= 0) {
                this.notifications.splice(index, 1);
            }
          }
        }
      );
    }
  }

  registerNotificationsJob() {
    if (this.isAuthurized) {
      this.loadNotifications();
    }
  }

  loadBoothsGames() {
    if (this.isAuthurized) {
      api.get("booths").then((res: AxiosResponse) => {
        this.filterBoothGames = res.data.data;
        this.boothGames = [];
        this.filterBoothGames.forEach((item: any) => {
          if (item.type === "game") {
            this.boothGames.push(item);
          }
        });
      });
    }
  }
  loadBoothsLessons() {
    if (this.isAuthurized) {
      api.get("booths").then((res: AxiosResponse) => {
        this.filterBoothLessons = res.data.data;
        this.boothLessons = [];
        this.filterBoothLessons.forEach((item: any) => {
          if (item.type === "lesson" || item.type === "interactive lesson") {
            this.boothLessons.push(item);
          }
        });
      });
    }
  }
  loadEvent() {
    if (this.isAuthurized) {
      this.$store.dispatch("fetchUserEvent");
    }
  }
  @Watch("$route")
  onUrlChange(newVal: Route) {
    this.mobileBoothTrainingHallToggle = false;
    this.mobileBoothChallengeHallToggle = false;
    this.boothsTrainingMenuToggle = false;
    this.boothsChallengeMenuToggle = false;
    this.mobileMenuToggle = false;
    this.menuToggle = false;
    this.loadBoothsGames();
    this.loadBoothsLessons();
    this.loadEvent();
  }

  hideMenu() {
    this.mobileMenuToggle = false;
    this.menuToggle = false;
    this.mobileBoothTrainingHallToggle = false;
    this.mobileBoothChallengeHallToggle = false;
    this.boothsTrainingMenuToggle = false;
    this.boothsChallengeMenuToggle = false;
  }

  goto(route: string) {
    this.menuToggle = false;
    this.mobileMenuToggle = false;

    if (route === "") {
      this.$router.push("/");
    } else if (this.$router.currentRoute.path !== route) {
      this.$router.push(route);
    }
  }

  isLTR() {
    return this.currentLanguage.direction === "ltr";
  }

  isRTL() {
    return !this.isLTR();
  }

  readNotification(item: any) {
    if (!item.is_read) {
      api
        .put("notifications/" + item.id)
        .then()
        .catch();
      // eslint-disable-next-line @typescript-eslint/camelcase
      item.is_read = true;
    }
    if (item.link) {
      this.$router.push(item.link);
    }
  }
  beforeDestroy() {
    this.$socket.client.off(
      "interactive_events_platform_database_NewNotification." + this.eventId
    );
    this.$socket.client.off(
      "interactive_events_platform_database_DeleteNotification." + this.eventId
    );
  }
  unread(notifications: any) {
    return Vue.filter("unread")(notifications);
  }
}
